import axios from 'axios';
import { callGlobalLogout } from '../store/authSession';

export const ACCESS_DENIED_MESSAGE = 'У тебя нет доступа к этой комнате или ресурс больше недоступен.';

export const isAccessDeniedError = (error) => {
  const status = error?.response?.status;
  return status === 403 || status === 404;
};

export const accessAwareMessage = (error, fallback) => (
  isAccessDeniedError(error) ? ACCESS_DENIED_MESSAGE : fallback
);

const api = axios.create();

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Перехватчик ответов для автоматического logout только при невалидной сессии.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      callGlobalLogout();
      // Не пробрасываем ошибку дальше, чтобы не показывать глобальное сообщение
      return Promise.resolve({});
    }
    return Promise.reject(error);
  }
);

export default api;
